import { createSafeClientData } from '@/services/core/core.service.ts'
import { serializeTypedFieldForExchange } from '@/common/utils/jsonUniData.ts'
import type { ExchangeData } from '@/services/action/types.ts'

/** Wire ExchangeData from En.getData() field map after local client_script run. */
export function exchangeDataFromEnFields(enFields: Record<string, unknown> | null | undefined): ExchangeData {
  const serialized: Record<string, unknown> = {}
  for (const [key, field] of Object.entries(enFields ?? {})) {
    serialized[key] = serializeTypedFieldForExchange(field)
  }
  return createSafeClientData({ fields: serialized })
}
